module.exports = __webpack_public_path__ + "44e14ba501ff2a401a4ba5c93d1b4126.fbx";